<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- Title-->
    <div>
      <HeaderComponent 
        :headerTitle="headerText" 
        :router-link="getRouterLink()" 
        :router-link-text="getRouterLinkText()" 
        :return-condition="true" 
        :component-name="componentsName()"/>
    </div>

    <v-card style="padding: 20px;">
      <v-row>

        <v-col cols="12" sm="4">
          <p><strong>
            Choose customer and Item resolution
            </strong>
          </p>
        </v-col>

        <v-col cols="12" sm="4">
          <input type="checkbox">
          Return with Debit
        </v-col>

        <v-col cols="12" sm="4">
          <v-text-field outlined v-model="select_recovery" label="Select Recovery Method" readonly disabled></v-text-field>
        </v-col>
      
      </v-row>
      <v-row>
        <v-col cols="12" sm="8">
        </v-col>

        

        <v-col cols="12" sm="2">
          <div>
            <div>
              <v-text-field outlined v-for="(field, index) in additionalTextFields" :key="field.id" label="Enter Vendor Id" type="text" v-model="field.value" />
            </div>
            <v-btn color="primary" outlined @click="handleAddTextField">Add Vendor</v-btn>
          </div>
        </v-col>

        <v-col cols="12" sm="2">
          <div>
            <div>
              <v-text-field outlined v-for="(field, index) in additionalTextFields" :key="field.id" v-model="field.debit_note" label="Debit Note Amount" :disabled="isDebitNoteButtonDisabled"></v-text-field>
            </div>
            <v-btn color="primary" outlined :disabled="(field, index) in additionalTextFields">Add Debit NOte</v-btn>
          </div>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="4">
        </v-col>

        <v-col cols="12" sm="4">
          <input type="checkbox">
          Return without Debit
        </v-col>

      </v-row>
     
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-text-field
            outlined
            v-model="comment"
            label="Add Comment"
            @click="toggleReject()"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
            class="ma-2 float-right"
            color="primary"
            :disabled="!comment">Approve</v-btn
          >
          <v-btn
            class="ma-2 float-right"
            color="primary"
            :disabled="!comment || !((currentUser.roles.includes('central_admin')) || (currentUser.roles.includes('site_admin')))">Re Propose</v-btn
          >
          <v-btn
            class="ma-2 float-right"
            color="primary"
            :disabled="!comment || !((currentUser.roles.includes('central_admin')) || (currentUser.roles.includes('site_admin')) || (currentUser.roles.includes('default_user')))">Reject</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent"; 

export default {
  components: {
    HeaderComponent,
  },
  data() {
    return {
      headerText: '',
      action: 'Approval Decision',
      replacementSelected: false,
      comment: '',
      select_recovery: '',
      vendor_id: '',
      debit_note: '',
      additionalTextFields: [ {
          id: "id" + Math.random().toString(36).substring(2),
          value: ""
        }
      ],
      textField: '',
      currentUser: {},
    }
  },
  computed: {
    isDebitNoteButtonDisabled() {
      return this.additionalTextFields.some(field => !field.value);
    },
  },
  async created() {
    this.currentUser = this.$store.state.currentUser;
    const returnApproval = this.$store.state.lotIds;
    alert(returnApproval)
  },
  methods:{ 
    getRouterLink() {
      if (this.headerText === 'Internal Return Request Approval') {
        this.$store.commit("setLotIds", {
          lotIds: this.$store.state.lotIds,
          inventoryId: "Internal Return Request Approval"
        });
        return { name: "sub_request_approval" };
      }
    },
    getRouterLinkText() {
      if (this.headerText === 'Internal Return Request Approval') {
        return 
      }
    },
    itemPopupDisplay(){
      this.itemPopup = true;
    },
    componentsName(){
      if (this.headerText === 'Internal Return Request Approval'){
        return 'Approval Decison';
      }
    },
    handleAddTextField() {
      const lastField = this.additionalTextFields[this.additionalTextFields.length - 1];
      if (lastField && lastField.value.trim() !== "") {
        let id = "id" + Math.random().toString(36).substring(2);
        this.additionalTextFields = [
        ...this.additionalTextFields,
        {
          id: id,
          },
        ];
      }
    },
  },
  async created(){
    this.item_id = this.$store.state.lotIds;
    this.headerText = this.$store.state.inventoryId;
  },
}
</script>